// This file provides language-agnostic normalization and mapping to internal statuses.
import TranslatedText from "./TranslatedText";

// Formatter fallback
export const formatStatus = (status) => {
  if (!status) return "Unknown";

  return status
    .toString()
    .replace(/[_-]/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

// Main function
export const getTranslatedStatus = (status, lang = "en") => {
  if (!status) return "Unknown";
  return <TranslatedText text={formatStatus(status)} />;
};

const SHIPPING_MESSAGE_MAP = new Map([
  ["announced", "AWAITING_SHIPMENT"],
  ["announced to carrier", "AWAITING_SHIPMENT"],
  ["driver en route", "SHIPPED"],
  ["being sorted", "SHIPPED"],
  ["at sorting centre", "SHIPPED"],
  ["en route to sorting center", "SHIPPED"],
  ["shipment picked up by driver", "SHIPPED"],

  ["out for delivery", "IN_TRANSIT"],
  ["delivery attempt failed", "IN_TRANSIT"],

  ["delivered", "DELIVERED"],

  ["refused by recipient", "RETURN_SHIPPED"],
  ["return in transit", "RETURN_SHIPPED"],

  ["returned to sender", "RETURN_RECEIVED"],

  ["cancelled", "CANCELLED"],
  ["cancelled upstream", "CANCELLED"],
  ["parcel cancellation failed", "CANCELLED"],
  ["order_received", "ORDER_RECEIVED"],
  ["order received", "ORDER_RECEIVED"],
]);

export const mapShippingMessageToInternalStatus = (message) => {
  if (!message) return null;
  const m = message.toString().trim().toLowerCase();
  if (SHIPPING_MESSAGE_MAP.has(m)) return SHIPPING_MESSAGE_MAP.get(m);
  if (m.includes("delivered")) return "DELIVERED";
  if (m.includes("out for delivery")) return "IN_TRANSIT";
  if (m.includes("parcel") && (m.includes("en route") || m.includes("enroute") || m.includes("route"))) return "SHIPPED";
  if (m.includes("picked up") || m.includes("picked up by")) return "SHIPPED";
  if (m.includes("returned to sender") || m.includes("returned")) return "RETURN_RECEIVED";
  if (m.includes("return") && m.includes("in transit")) return "RETURN_SHIPPED";
  if (m.includes("cancel")) return "CANCELLED";
  if (m.includes("announc")) return "AWAITING_SHIPMENT";
  if (m.includes("received") && m.includes("order")) return "ORDER_RECEIVED";
  return null;
};

// order tracker status handle 
export const getStepFromStatus = (isReturn = false, isRefunded = false, status) => {
  if (!status) return 1;
  const raw = status.toString().trim();
  const s = raw.toLowerCase();
  const up = raw.toUpperCase();
  const internalCandidates = [
    "AWAITING_SHIPMENT",
    "SHIPPED",
    "IN_TRANSIT",
    "DELIVERED",
    "RETURN_SHIPPED",
    "RETURN_RECEIVED",
    "CANCELLED",
    "ORDER_RECEIVED",
    "REFUNDED",
  ];

  let internal = null;
  if (internalCandidates.includes(up)) internal = up;
  if (!internal) internal = mapShippingMessageToInternalStatus(raw);

  // If order was marked refunded while already delivered, treat as refunded step
  // if (isRefunded && (internal === "DELIVERED" || up === "DELIVERED" || s.includes("delivered"))) return 7;
  if (isRefunded) return 7;
  if (isReturn) {
    return 6;
  }
  // if (isReturn) {
  //   if (s.includes("refunded") || up === "REFUNDED" || s.includes("refund") || up === "DELIVERED") return 7;
  //   if (
  //     s.includes("return") ||
  //     s.includes("returned") ||
  //     s.includes("returning") ||
  //     internal === "RETURN_SHIPPED" ||
  //     internal === "RETURN_RECEIVED"
  //   ) {
  //     return 6;
  //   }
  // }
  if (s.includes("placed") || up === "ORDER_RECEIVED" || s.includes("order received")) return 1;
  if (internal === "AWAITING_SHIPMENT" || s.includes("label") || s.includes("ready") || s.includes("ready to send")) return 2;
  if (internal === "SHIPPED" || s.includes("shipped") || s.includes("parcel")) return 3;
  if (internal === "IN_TRANSIT" || s.includes("out for delivery") || s.includes("delivery attempt")) return 4;
  if (internal === "DELIVERED" || s.includes("delivered")) return 5;
  return 1;
};


export const normalizeStatus = (status) => {
  if (status === null || status === undefined) return null;
  const raw = status.toString().trim();
  if (raw.length === 0) return null;
  const up = raw.toUpperCase();
  if (up === "DELIVERED" || up === "CANCELLED" || up === "FAILED" || up === "PENDING") return up;
  const internalCandidates = [
    "AWAITING_SHIPMENT",
    "SHIPPED",
    "IN_TRANSIT",
    "DELIVERED",
    "RETURN_SHIPPED",
    "RETURN_RECEIVED",
    "CANCELLED",
    "ORDER_RECEIVED",
  ];
  if (internalCandidates.includes(up)) return up;
  const mapped = mapShippingMessageToInternalStatus(raw);
  if (mapped) return mapped;
  const s = raw.toLowerCase();
  if (s.includes("delivered")) return "DELIVERED";
  if (s.includes("cancel")) return "CANCELLED";
  if (s.includes("fail")) return "FAILED";
  if (s.includes("pending")) return "PENDING";
  return raw;
};
